<template>
  <div class="profile-dialog-header entity-form-dialog__header">
    <div class="entity-form-dialog__title">
      <v-avatar size="44" color="green lighten-5">
        <v-icon color="primary">{{ icon }}</v-icon>
      </v-avatar>
      <div>
        <span>{{ eyebrow }}</span>
        <h2>{{ title }}</h2>
        <p v-if="subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <v-btn icon :aria-label="closeLabel" @click.stop="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "EntityDialogHeader",
  props: {
    eyebrow: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "mdi-form-select" },
    closeLabel: { type: String, default: "Close dialog" },
  },
};
</script>
